@if (data) {
    <div>
      <h3 class="text-lg font-semibold text-gray-900 mb-1">Study Name: {{ data.study_name }}</h3>
      <p class="font-poppins text-gray-800"><strong>Study Description :</strong> {{ data.study_description }}</p>
    </div>
  }
  